export { renderOverlayLayers, renderOverlayPrimitives } from './overlayRenderer.js';

export function captureVideoFrame(
  video: HTMLVideoElement,
  canvas: HTMLCanvasElement,
  context: CanvasRenderingContext2D,
): ImageData {
  const width = video.videoWidth;
  const height = video.videoHeight;
  if (width <= 0 || height <= 0) throw new Error('Video frame dimensions are not available.');

  canvas.width = width;
  canvas.height = height;
  context.drawImage(video, 0, 0, width, height);
  return context.getImageData(0, 0, width, height);
}

export function renderLuminanceHistogram(
  canvas: HTMLCanvasElement,
  context: CanvasRenderingContext2D,
  bins: readonly number[],
): void {
  const width = 320;
  const height = 90;
  canvas.width = width;
  canvas.height = height;
  context.clearRect(0, 0, width, height);
  context.fillStyle = '#0a0d0b';
  context.fillRect(0, 0, width, height);
  if (!bins.length) return;

  const barWidth = width / bins.length;
  bins.forEach((value, index) => {
    const normalized = Math.max(0, Math.min(1, value));
    const barHeight = normalized * (height - 8);
    const shade = Math.round((index / Math.max(1, bins.length - 1)) * 205 + 40);
    context.fillStyle = `rgb(${shade}, ${shade}, ${shade})`;
    context.fillRect(index * barWidth, height - barHeight, Math.max(1, barWidth - 1), barHeight);
  });
}
